












import {
  computed,
  defineComponent, ref, useContext, watch,
} from '@nuxtjs/composition-api';
import {useUrl} from "~/composables/Palmers";

export default defineComponent({
  name: 'ElementFavoriteCategories',
  props: {
    element: {
      type: Object,
      require: true
    }
  },
  components: {
    FavoriteCategories: () => import("~/components/Palmers/Category/FavoriteCategories.vue")
  },
  setup(props) {
    const favCategories = ref([]);
    const {getMediaUrl} = useUrl();

    //@ts-ignore
    const {$vsf, $pinia} = useContext();

    const categories = computed(() => $pinia.state.value.category?.rawCategories?.items[0]);

    const filterObjectsByFavorite = (obj) => {
      let result = [];

      if (Array.isArray(obj)) {
        for (const child of obj) {
          result = result.concat(filterObjectsByFavorite(child));
        }
      } else if (typeof obj === 'object' && obj !== null) {
        if (obj.category_is_favorite === 1) {
          result.push({
            ...obj,
            title: obj.name,
            subtitle: obj['short_description_content'],
            img_type: 'category_wall_2x2',
            image: (obj['favorite_category_image'] ? getMediaUrl(obj['favorite_category_image']) : $vsf.$magento.config.magentoBaseUrl)
          });
        }

        for (const key in obj) {
          if(Object.hasOwnProperty.call(obj, key)) {
            result = result.concat(filterObjectsByFavorite(obj[key]));
          }
        }
      }

      return result;
    }

    const buildCategoryWall = () => {
      if (categories.value) {
        favCategories.value = filterObjectsByFavorite(categories.value);
      }
    }

    buildCategoryWall();

    watch(categories, () => {
      buildCategoryWall();
    }, { immediate: true });


    return {
      favCategories
    }
  },
});
